
import { Options, Vue } from "vue-class-component";
import { useStore } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { router } from "@/router";
import { getModuleTitle, generateImageUrl } from "../utils/modules";
import { calculateActivePage } from "../utils/pages";
import { wrapper } from "../utils/wrapper";
import ApiService from "@/services/ApiService";
import StorageService from "@/services/StorageService";
import ModuleProgresBar from "./ModuleProgressBar.vue"

@Options({
  components: {
    FontAwesomeIcon,
    ModuleProgresBar
  },
  methods: {
    generateImageUrl: generateImageUrl
  },
  props: {
    module: Object,
    userLanguage: String
  }
} as any)
export default class Module extends Vue {
  globalStore = useStore();
  private apiService = new ApiService();
  private storageService = new StorageService();
  userLanguage: any = null;
  detailedModule: any = null;
  module: any = null;
  pageState: any = null;
  title = null;
  dependsOnTargetTitle = "";
  user: any = null;
  firstPage: any = null;

  async created() {
    this.user = this.storageService.getUser();
    this.title = await getModuleTitle(this.module, this.userLanguage);
  }

  async getModule(module: { id: number }) {
    const dataResponse = await wrapper(
      this.apiService.getModule(this.user.patientsId, module.id)
    );
    if (dataResponse.error) {
      console.error("get module error ", dataResponse.error.data);
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.MODULES.GET_CURRENT_MODULE.FAILED.TITLE"),
        text: this.$t("ALERTS.MODULES.GET_CURRENT_MODULE.FAILED.TEXT")
      });
    }
    if (
      dataResponse.data &&
      dataResponse.data.pages &&
      dataResponse.data.pages[0]
    ) {
      this.detailedModule = dataResponse.data;

      this.pageState = calculateActivePage(dataResponse.data.pages);
    }
  }

  generateCircleLeftSpacing() {
    // The value on this formula are related with the current values on the CSS side
    return this.module.state.progress - 11 < 0
      ? 0
      : this.module.state.progress - 11;
  }

  async navigateToModulePage(module: any) {
    await this.getModule(module);

    if (this.module.enabled) {
      router.push({
        name: "Page",
        params: {
          moduleId: this.detailedModule.id,
          pageId: this.pageState.pagesId,
          pageStateId: this.pageState.id
        }
      });
    }
  }
}
